import React, { useState } from "react";
import ClientService from "../../services/ClientService";
import PersonalizeCard from "../../services/PersonalizeCard";
import countries from "i18n-iso-countries";
import english from "i18n-iso-countries/langs/en.json";
import alerts from "../utils/validations";
import styled from "styled-components";
import { Form, InputGroup } from "react-bootstrap";
import DatePicker from "react-datepicker";

import UnregisteredUser from "./UnregisteredUser";
import validator from 'validator';
import ModalGenerarCodigoOtpShow from '../ModalGenerarCodigoOtp/modal';

countries.registerLocale(english);

const ContainerCheckbox = styled.div`
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-evenly',
  alignItems: 'center',
  `;

const FormDataPersonal = ({ setFormPersonalizar,showFormUser, listaCountry, listaCards }) => {
  const [isNational, setIsNacional] = useState(true); //Para saber si el cliente a personalizar es nacional o extranjero
  const [document, setDocument] = useState(""); // Para guardar el valor del campo cédula o pasaporte en el formulario
  const [bloqueaDocument, setBloqueaDocument] = useState(false); //Permite bloquear el campo cédula o pasaporte en el caso de que sean correctos
  const [bloqueaBtnRegistrar, setBloqueaBtnRegistrar] = useState(true); //Permite desbloquear el botón registrar en el caso de que la cédula o pasaporte consultado sea correcto
  const [country, setCountry] = useState(""); // Para guardar el país
  const [name, setName] = useState(""); // Para guardar el nombre del cliente
  const [surname, setSurname] = useState(""); // Para guardar el apellido del cliente
  const [phone, setPhone] = useState(""); // Para guardar el celular o teléfono del cliente
  const [email, setEmail] = useState(""); // Para guardar el email o correo del cliente
  const [validateEmail, setValidateEmail] = useState(false); // Para validar el email en el formulario
  const [birthday, setBirthday] = useState(new Date); // Guarda la fecha de nacimiento del cliente del formulario
  const [birthdayKbus, setBirthdayKbus] = useState(""); // Guarda la fecha de nacimiento del cliente devuelta en el recurso
  const [nroCard, setNroCard] = useState("");
  const [isRegisterUser, setIsRegisterUser] = useState(false); // Valida que el formulario a registrar está ok
  const [sendCode, setSendCode] = useState(false); // 
  const [codigoOtp, setCodigoOtp] = useState(""); // Guarda el valor del código
  const [valorValidadoRecursoSearchUser, setValorValidadoRecursoSearchUser] = useState("");
  const [modalGenerarCodigoOtpShow, setModalGenerarCodigoOtpShow] = useState(false);
  const UseInput = ({
    id,
    value,
    onBlur,
    type = "text",
    placeholder,
    className = "input-lineal",
    pattern,
    feedback,
  }) => {
    return (
      <Form.Group controlId={`Form-${id}`}>
        <Form.Control
          onBlur={(e) => onBlur(e.target.value)}
          defaultValue={value}
          type={type}
          required
          placeholder={placeholder}
          className={className}
          pattern={pattern}
          autoComplete="off"
        />
        <Form.Control.Feedback type="invalid">{feedback}</Form.Control.Feedback>
      </Form.Group>
    );
  };

  // Esta funcion se puede sacar a utils para reutilizarla, sirve para validar la cédula
  function validateCedula(cad, msg) {
    let total = 0;
    let longitud = cad.length;
    let longcheck = longitud - 1;

    if (cad !== "" && longitud === 10) {
      for (let i = 0; i < longcheck; i++) {
        if (i % 2 === 0) {
          var aux = cad.charAt(i) * 2;
          if (aux > 9) aux -= 9;
          total += aux;
        } else {
          total += parseInt(cad.charAt(i)); // parseInt o concatenará en lugar de sumar
        }
      }

      total = total % 10 ? 10 - (total % 10) : 0;

      const isValid = cad.charAt(longitud - 1) == total;
      return isValid;
    }
    return false;
  }
  // Función para validar cédula y ruc 
  function validateCedulaRuc() {
    const validCedula = validateCedula(
      document,
      "Por favor ingrese una cédula válida"
    );
    const validRuc = alerts.validationRuc(document);

    if (!validCedula && !validRuc) {
      if (document.length == 10) {
        alerts.warningAlert(
          "Cédula no válida",
          "Por favor ingrese una cédula válida"
        );
        return false;
      } else {
        if (!validRuc) {
          alerts.warningAlert(
            "RUC no válido",
            "Por favor ingrese un RUC válido"
          );
          return false;
        }
      }
    }
    return true;
  }

  // Función para enviar a obtener datos del registro civil o Kbus
  function findDocument() {
    // if (validateCedulaRuc()) {
      alerts.loadingAlert("Consultando información", "");
      ClientService.findDataBaseKbus(document,isNational,country)
        .then((response) => {
          if (response.en === 1) {
            setValorValidadoRecursoSearchUser(response.validado);
            if(response.validado === 1 || response.validado === 2 || response.validado === 3) {
              setIsRegisterUser(true);
              setBloqueaDocument(true);
              setBloqueaBtnRegistrar(false);
              if(response.validado === 2 || response.validado === 3) {
                setSendCode(true);
              }else {
                setSendCode(false);
              }
              var user = "";
              if(response.validado === 1 || response.validado === 3) {
                user = response.datos[0];
              }else {
                user = response.data[0];
              }
              if(user.nombre) {
                var fecha = new Date(user.fechaNac);
                var fechaConSignoDivision = user.fechaNac.includes('/');
                var dateFormat = "";
                if(fechaConSignoDivision) {
                  var fechaDividida = user.fechaNac.split("/");
                  fechaDividida = fechaDividida[2] + "-" + fechaDividida[1] + "-" + fechaDividida[0];
                  fecha = new Date(fechaDividida);
                  dateFormat = new Date(fecha.setDate(fecha.getDate() + 1));
                }else{
                  dateFormat = new Date(fecha.setDate(fecha.getDate() + 1));
                }
                setName(user.nombre);
                setSurname(user.apellido);
                setEmail(user.correo);
                // setBirthday(dateFormat);
                setBirthdayKbus(dateFormat);
                setPhone(user.celular);
              }else {
                setName();
                setSurname();
                setEmail();
                // setBirthday();
                setBirthdayKbus();
                setPhone();
              }
            } else {
              alerts.warningAlert(
                "Aviso.",
                response.m + "."
              );
              return;
            }
          } else {
              setName();
              setSurname();
              setEmail();
              // setBirthday();
              setBirthdayKbus();
              setPhone();
              setIsRegisterUser(false);
              setBloqueaDocument(false);
              setBloqueaBtnRegistrar(true);
              alerts.warningAlert(
                "Aviso.",
                response.m+ "."
              );
              return;
          }
          window.Swal.close();
        })
        .catch((error) => {
          console.log(error);
          setIsRegisterUser(false);
          setSendCode(true);
          alerts.warningAlert(
            "No se han encontrado datos.",
            "No se ha encontrado datos para el número de cédula ingresado, por favor llene el formulario."
          );
        });
    }
  // }

  // Función que cambia el estado para presentar el formulario que permite enviar un código
  function setFormEnviarCodigo() {
    setSendCode(false);
  }
  // Función la cual indica que se va a enviar a registrar la personalización
  function setRegistrarUsuario() {
    setIsRegisterUser(true);
  }
  // Función que permite guardar el código OTP
  function setGuardarCodigo(codigo) {
    setCodigoOtp(codigo);
  }
  // Función que permite guardar el correo
  function setGuardarCorreo(correo) {
    setEmail(correo);
  }
  // Función que permite guardar el número de celular
  function setGuardarTeléfono(telefono) {
    setPhone(telefono);
  }
  //
  function esNacional() {
    setIsNacional(true);
    setSendCode(false);
  }
  function esExtranjero() {
    setIsNacional(false);
  }

  function handleLimpiar() {
    if(isNational) {
      setIsNacional(true);
    }else {
      setIsNacional(false);
    }
    setDocument("");
    setBloqueaDocument(false);
    setBloqueaBtnRegistrar(true);
    //setCountry();
    setName();
    setSurname();
    setPhone();
    setEmail();
    setValidateEmail(false);
    setBirthday(new Date);
    setBirthdayKbus();
    setIsRegisterUser(false);
    setSendCode(false);
    setCodigoOtp();
    setValorValidadoRecursoSearchUser();
  }


  // función que permite enviar a registrar (personalizar tarjeta)
  const handleSubmitUser = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setValidateEmail(true);
    var fechaNueva = "";
    var fechaAnterior = "";
    
    // if (validateCedulaRuc()) {
      if (document && name && surname && phone && email && birthday) {
        if (isRegisterUser) {
          var mesNuevo = birthday.getMonth() + 1;
          if(mesNuevo.toString().length == 1) {
            mesNuevo = '0' + mesNuevo;
          }
          var mesAnterior = "";
          if(birthdayKbus) {
            mesAnterior = birthdayKbus.getMonth() + 1;
            if(mesAnterior.toString().length == 1) {
              mesAnterior = '0' + mesAnterior;
            }
          }
          var diaNuevo = birthday.getDate();
          if(diaNuevo.toString().length == 1) {
            diaNuevo = '0' + diaNuevo;
          }
          var diaAnterior = "";
          if(birthdayKbus) {
            diaAnterior = birthdayKbus.getDate();
            if(diaAnterior.toString().length == 1) {
              diaAnterior = '0' + diaAnterior;
            }
          }
          fechaNueva = birthday.getFullYear() + "-" + mesNuevo + "-" + diaNuevo;
          if(birthdayKbus) {
            fechaAnterior = birthdayKbus.getFullYear() + "-" + mesAnterior + "-" + diaAnterior;
          }
          if(valorValidadoRecursoSearchUser === 1) {            
            if(isNational) {
              if (fechaNueva !== fechaAnterior) {
                alerts.warningAlert(
                  "Fecha no válida",
                  "Por favor verifique la fecha de nacimiento. <br><b>La fecha ingresada no coincide con la registrada en el sistema.</b>"
                );
                return;
              }
            } 
          }
          alerts.loadingAlert("Personalizando tarjeta", "");
          PersonalizeCard.personaliceCard(listaCards[0].id_tarjeta,document,name,surname,fechaNueva,email,country,isNational,codigoOtp,phone)
          .then((response) => {
            if (response.en == 1) {
              window.Swal.close();
              setName();
              setSurname();
              setEmail();
              setBirthday();
              setBirthdayKbus();
              setPhone();
              setIsRegisterUser(false);
              setFormPersonalizar();
              alerts.warningAlert(
                "Personalización de tarjeta.",
                response.m+"."
              );
              return;
            } else {
                alerts.warningAlert(
                  "No se han encontrado datos.",
                  "Validación "+response.validado+ "."
                );
            }
            window.Swal.close();
          })
          .catch((error) => {
            alerts.warningAlert(
              "Error al personalizar tarjeta.",
              error.m
            );
          });
        }
      } else {
        alerts.warningAlert(
          "Aviso",
          "Todos los campos son obligatorios."
        );
        return;
      }
    // }
  };

  // función que permite validar el pasaporte
  const handleValidatePassport = (e) => {
    console.log("Validar Pasaporte")
    console.log('Pasaporte', document) 

    const us = countries.getAlpha2Code(country, "en");
    console.log("Codigo PAIS: ",us);

    // ECU A7994154
    if(validator.isPassportNumber('ZAB000221', "ES")){
      alerts.successAlert('Pasaporte Valido', 'Correcto')
    }else{
      alerts.warningAlert('Pasaporte No valido', 'Incorrecto')
    }
    
  }

  const listOptionPais = listaCountry.map((number) =>
    <option key={number.id_pais} value={number.id_pais}>{number.pais}</option>
  );

  return (
    <div className="col-md-12">
      <h3 className="text-primary font-weight-bold mt-6">Datos Usuario</h3>

      <ContainerCheckbox
        className="radio"
        onChange={(e) =>
          e.target.value === "nacional"
            ? esNacional()
            : esExtranjero()
        }
      >
        <div>
          <label>
            <input
              type="radio"
              value="nacional"
              name="nacionalidad"
              defaultChecked
            />
            <span className="check-box-effect"></span>
            <span className="textlabel">Nacional</span>
          </label>
        </div>
        <div>
          <label>
            <input type="radio" value="extrangero" name="nacionalidad" />
            <span className="check-box-effect"></span>
            <span className="textlabel">Extranjero</span>
          </label>
        </div>
      </ContainerCheckbox>
      <Form
      validated={validateEmail}
      >
        {!isNational ? (
          <Form.Group controlId="formBasicSelect">
            <Form.Control
              as="select"
              value={country}
              onChange={(e) => setCountry(e.target.value)}
            >
              <option value="" disabled>Seleccione el país...</option>
              {listOptionPais}
            </Form.Control>
          </Form.Group>
        ) : null}
        {/* CAMPO CÉDULA O PASAPORTE */}
        <Form.Group controlId="formSearch">
          <InputGroup>
            <Form.Control
              value={document}
              onChange={(e) => setDocument(e.target.value)}
              type="text"
              required
              pattern = "^[a-z0-9-]{8,16}"
              className="input-lineal"
              autoComplete="off"
              placeholder={
                isNational ? "Ingresa tu cédula" : "Ingresa tu pasaporte"
              }
              disabled = {bloqueaDocument ? 1 : 0}
            />
            <InputGroup.Prepend>
              {/* <InputGroup.Text
                id="inputPrepend"
                onClick={() => findDocument()}
                className="pointer"
                hidden = {bloqueaDocument ? 1 : 0}
              >
                <i className="fa fa-search" hidden = {bloqueaDocument ? 1 : 0}></i>
              </InputGroup.Text> */}
              <button type="button" onClick={() => findDocument()}><i className="fa fa-search"></i></button>
            </InputGroup.Prepend>
            <Form.Control.Feedback type="invalid">
              Ingrese {isNational? "una cédula válida" : "un pasaporte válido"}
            </Form.Control.Feedback>
          </InputGroup>
        </Form.Group>

        {!sendCode ? (
          <>
            <UseInput
              id="username"
              value={name}
              onBlur={setName}
              placeholder="Nombre..."
              className="input-lineal"
              pattern="^([a-zA-Z]{2})+[a-zA-Z ]+"
              feedback="El nombre es obligatorio"
            />

            <UseInput
              id="surname"
              value={surname}
              onBlur={setSurname}
              placeholder="Apellido..."
              pattern="^([a-zA-Z]{2})+[a-zA-Z ]+"
              feedback="El apellido es obligatorio"
            />

            <UseInput
              id="phone"
              value={phone}
              onBlur={setPhone}
              placeholder="Teléfono..."
              pattern="\d{7,}"
              feedback="Ingrese un teléfono válido"
              autoComplete="off"
            />

            <Form.Group controlId="validationEmail">
              <Form.Control
                className="input-lineal"
                defaultValue= {email}
                type="email"
                placeholder="Ingrese un correo electrónico"
                pattern="^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$"
                onBlur={(e) => setEmail(e.target.value)}
                required
                autoComplete = "off"
              />
              <Form.Control.Feedback type="invalid">
                Por favor ingrese un correo válido.
              </Form.Control.Feedback>
              <Form.Control.Feedback type="valid">
                Correo válido.
              </Form.Control.Feedback>
            </Form.Group>

            <div className="mb-3 w-100">
              <DatePicker
                onChange={(date) => setBirthday(date)}
                showYearDropdown
                yearDropdownItemNumber={80}
                scrollableYearDropdown
                maxDate={new Date()}
                selected={birthday}
                dateFormat="yyyy-MM-dd"
                className="form-control input-lineal w-100"
                required
                placeholderText="Fecha de nacimiento"
              />
              <small className="form-text text-muted">
                Formato fecha: YYYY-MM-DD
              </small>
              <div className="verificaPadre">
                <p className="text-primary font-weight-bold verifica">
                  ¿Estás seguro que es el número de tarjeta{" "}
                  <span className="numero">{nroCard}</span> correcto? <br></br>
                  Verifícalo para evitar errores.
                </p>
              </div>
            </div>
          </>
        ) : null}
      </Form>
      {/*Botón y función para enviar a registrar*/}
      {showFormUser && !sendCode && (
        <div className="text-center">
          <button
            className="btn btn-primary"
            type="submit"
            disabled = {bloqueaBtnRegistrar ? 1 : 0}
            onClick={(e) => handleSubmitUser(e)}
          >
            Registrar
          </button>
          <button
            className="btn btn-primary"
            type="submit"
            onClick={(e) => handleLimpiar(e)}
          >
            Limpiar
          </button>
        </div>
      )}
      {/* <button
        className="btn btn-primary"
        type="submit"
        onClick={handleValidatePassport}
      >
        Validar Pasaporte
      </button> */}
      <UnregisteredUser 
        listaCards={listaCards} 
        isActive={sendCode}
        setFormEnviarCodigo = {setFormEnviarCodigo.bind(this)}
        setRegistrarUsuario = {setRegistrarUsuario.bind(this)}
        setGuardarCodigo = {setGuardarCodigo.bind(this)}
        setGuardarCorreo = {setGuardarCorreo.bind(this)}
        setGuardarTeléfono = {setGuardarTeléfono.bind(this)}
        handleLimpiar = {handleLimpiar.bind(this)}
      />
      {/* {
        modalGenerarCodigoOtpShow ?
          <ModalGenerarCodigoOtpShow show={modalGenerarCodigoOtpShow} onHide={() => setModalGenerarCodigoOtpShow(false)} />
        : null
      } */}
    </div>
  );
};

export default FormDataPersonal;
